/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */

export class DeviceMeta {
    installedIn: string
    registeredTo: string
    lastSeenAt: string
    id: string
    createdAt: string
    updatedAt: string
}
